import React, { useEffect, useState } from "react";
import { getbustriplog, getBusTripLogExport } from "../../services/TransportService";
import { Spinner } from "react-bootstrap";
import DataTable from "react-data-table-component";
import Pagination from "../Constant/Pagination";
import { CancelRequest } from "../../services/AxiosInstance";
import DebounceSearchInput from "../Constant/DebounceSearchInput";
import { useParams } from "react-router-dom";
import { PiExportBold } from "react-icons/pi";
import { Tooltip } from "@mui/material";
import format from "date-fns/format";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import { CustomTooltip } from "../../components/CustomTooltip";
const BusTripLogs = ({busId}) => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [exportloading, setExportloading] = useState(false);
  const [error, setError] = useState("");
  const [param, setParam] = useState({
    query: "",
    // start_date: format(subDays(new Date(), 7), "yyyy-MM-dd"),
    // end_date: format(new Date(), "yyyy-MM-dd"),
    page: "1",
    page_size: "10",
  });
  const getdata = () => {
    setLoading(true);
    getbustriplog(busId||id, param)
      .then((res) => {
        setData(res?.data?.results || []);
        setTotal(res.data?.count || 0);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getdata();
  }, [param, id,busId]);
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };
 const handleexport = () => {
      setExportloading(true);
      const newparam = { ...param, export: true };
      getBusTripLogExport(id,newparam)
        .then((res) => {
          const blob = new Blob([res.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);
  
          const a = document.createElement("a");
          a.href = url;
          a.download = "Trip Log.xlsx"; // set your desired filename
          a.click();
  
          window.URL.revokeObjectURL(url); // clean up
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setExportloading(false);
        });
    };
  if (error) {
    return <div className="alert alert-danger m-2">{error}</div>;
  }
  return (
    <div>
      <div className="d-flex justify-content-end px-1 mb-2">
        <div className="d-flex gap-1">
          <DebounceSearchInput handleSearchChange={handleSearchChange} />
          <CustomTooltip title="Export" arrow>
            <span
              className="me-2 cursor-pointer d-inline-flex align-items-center justify-content-center bus-action-button"
              style={{padding:'11px'}}
              onClick={handleexport}
              // style={{
              //   padding: "0px 15px",
              //   backgroundColor: "rgb(226, 225, 225)",
              //   borderRadius: "5px",
              // }}
              // style={{ width: "24px", height: "24px" }}
            >
              {exportloading ? (
                <Spinner animation="border" variant="primary" size="sm" />
              ) : (
                <PiExportBold size={18} />
              )}
            </span>
          </CustomTooltip>
        </div>
      </div>
      <div>
        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : !data || data.length === 0 ? (
          <div className="my-2 text-center">There are no records found.</div>
        ) : (
          <div className="table-responsive">
            <table className="table fs-6 align-middle mb-0">
              <thead className="custom-thead table-light">
                <tr>
                  <th>Route Name</th>
                  <th>Shift</th>
                  <th>Driver</th>
                  <th>Schedule</th>
                  <th>Actual</th>
                  <th>Trip</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row, index) => {
                  const tripModeClass =
                    row?.trip_mode?.toLowerCase() === "pickup"
                      ? "text-bg-success-soft"
                      : "text-bg-info-soft";
                  return (
                    <tr key={index}>
                      <td>{row?.route?.name || "NA"}</td>
                      <td>{row?.shift?.name || "NA"}</td>
                      <td>{row?.driver?.name || "NA"}</td>

                      <td>
                        {row?.stop_schedule_time
                          ? format(
                              new Date(`1970-01-01T${row.stop_schedule_time}`),
                              "hh:mm a"
                            )
                          : "NA"}
                      </td>
                      <td>
                        {row?.actual_time
                          ? format(
                              new Date(`1970-01-01T${row?.actual_time}`),
                              "hh:mm a"
                            )
                          : "NA"}
                      </td>
                      <td>
                        {" "}
                        <span className={`badge ${tripModeClass}`}>
                          {row.trip_mode || "N/A"}
                        </span>
                      </td>
                      <td>
                        <span>{row?.created_at?(format(row?.created_at,'dd MMM yyy')):'N/A'}</span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {!loading && data && data.length > 0 && (
          <div className="px-2 border-top">
            <Pagination
              currentPage={param.page}
              recordsPage={param.page_size}
              dataLength={total}
              handlePagination={handlePageChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default BusTripLogs;
